import { UpdateUserSettingsMutation } from './update-user-settings-mutation';
export var endpoints = {
    updateUserSettingsMutation: new UpdateUserSettingsMutation(),
};
